import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import type { PermissionId } from "@/modules/roles/domain/contracts/permissions";
import { useCreateRole } from "../api/queries";
import { RoleForm } from "../ui/RoleForm";

export function RoleCreatePage() {
  const nav = useNavigate({ from: "/app/roles/create" });
  const createRole = useCreateRole();

  return (
    <>
      <Header />
      <Main>
        <div className="space-y-4">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div>
              <h1 className="font-semibold text-2xl">ສ້າງບົດບາດ</h1>
              <p className="text-muted-foreground">
                ກໍານົດຊື່, ຄໍາອະທິບາຍ, ແລະສິດທິຂອງບົດບາດ.
              </p>
            </div>

            <Button
              type="button"
              variant="outline"
              onClick={() => nav({ to: "/app/roles" })}
            >
              <ArrowLeftIcon className="mr-2 h-4 w-4" />
              ກັບຄືນ
            </Button>
          </div>

          <div className="rounded-xl border bg-card p-6">
            <RoleForm
              onSubmit={async (vals) => {
                await createRole.mutateAsync({
                  name: vals.name ?? "",
                  description: vals.description ?? null,
                  permissions: vals.permissions as PermissionId[],
                });
                nav({ to: "/app/roles" });
              }}
              submitting={createRole.isPending}
            />
          </div>
        </div>
      </Main>
    </>
  );
}
